<template>
  <svg
    width="162"
    height="161"
    viewBox="0 0 162 161"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.06"
      d="M80 140C113.137 140 140 113.137 140 80C140 46.8629 113.137 20 80 20C46.8629 20 20 46.8629 20 80C20 113.137 46.8629 140 80 140Z"
      fill="url(#paint0_linear_10073_64872)"
    />
    <g filter="url(#filter0_d_10073_64872)">
      <path
        d="M122.34 130.662H39.5851C37.0431 130.662 34.9248 128.613 34.9248 125.999V33.0092C34.9248 30.4654 36.9725 28.4163 39.5851 28.4163H122.34C124.882 28.4163 127 30.4654 127 33.0799V125.999C127 128.543 124.953 130.662 122.34 130.662Z"
        fill="url(#paint1_linear_10073_64872)"
      />
    </g>
    <path
      opacity="0.04"
      d="M117.185 56.4686H44.174C43.3267 56.4686 42.6206 55.762 42.6206 54.9141V41.0645C42.6206 40.2166 43.3267 39.51 44.174 39.51H117.185C118.032 39.51 118.738 40.2166 118.738 41.0645V54.8434C118.809 55.762 118.103 56.4686 117.185 56.4686Z"
      fill="url(#paint2_linear_10073_64872)"
    />
    <path
      d="M50.2467 50.109C51.4166 50.109 52.365 49.16 52.365 47.9892C52.365 46.8185 51.4166 45.8694 50.2467 45.8694C49.0768 45.8694 48.1284 46.8185 48.1284 47.9892C48.1284 49.16 49.0768 50.109 50.2467 50.109Z"
      fill="url(#paint3_linear_10073_64872)"
    />
    <path
      opacity="0.24"
      d="M102.357 49.4025H59.4963C59.1433 49.4025 58.8608 49.1198 58.8608 48.7665V47.1413C58.8608 46.788 59.1433 46.5054 59.4963 46.5054H102.357C102.71 46.5054 102.992 46.788 102.992 47.1413V48.7665C102.992 49.1198 102.71 49.4025 102.357 49.4025Z"
      fill="url(#paint4_linear_10073_64872)"
    />
    <path
      opacity="0.04"
      d="M117.185 78.2322H44.174C43.3267 78.2322 42.6206 77.5256 42.6206 76.6776V62.8988C42.6206 62.0508 43.3267 61.3442 44.174 61.3442H117.185C118.032 61.3442 118.738 62.0508 118.738 62.8988V76.6776C118.809 77.5256 118.103 78.2322 117.185 78.2322Z"
      fill="url(#paint5_linear_10073_64872)"
    />
    <path
      d="M50.2467 71.8727C51.4166 71.8727 52.365 70.9236 52.365 69.7529C52.365 68.5821 51.4166 67.6331 50.2467 67.6331C49.0768 67.6331 48.1284 68.5821 48.1284 69.7529C48.1284 70.9236 49.0768 71.8727 50.2467 71.8727Z"
      fill="url(#paint6_linear_10073_64872)"
    />
    <path
      opacity="0.24"
      d="M102.357 71.2367H59.4963C59.1433 71.2367 58.8608 70.954 58.8608 70.6007V68.9755C58.8608 68.6222 59.1433 68.3396 59.4963 68.3396H102.357C102.71 68.3396 102.992 68.6222 102.992 68.9755V70.6007C102.992 70.954 102.71 71.2367 102.357 71.2367Z"
      fill="url(#paint7_linear_10073_64872)"
    />
    <path
      opacity="0.04"
      d="M117.185 121.83H44.174C43.3267 121.83 42.6206 121.123 42.6206 120.275V106.496C42.6206 105.649 43.3267 104.942 44.174 104.942H117.185C118.032 104.942 118.738 105.649 118.738 106.496V120.275C118.809 121.123 118.103 121.83 117.185 121.83Z"
      fill="url(#paint8_linear_10073_64872)"
    />
    <path
      d="M50.2467 115.47C51.4166 115.47 52.365 114.521 52.365 113.351C52.365 112.18 51.4166 111.231 50.2467 111.231C49.0768 111.231 48.1284 112.18 48.1284 113.351C48.1284 114.521 49.0768 115.47 50.2467 115.47Z"
      fill="url(#paint9_linear_10073_64872)"
    />
    <path
      opacity="0.24"
      d="M102.357 114.764H59.4963C59.1433 114.764 58.8608 114.481 58.8608 114.128V112.503C58.8608 112.149 59.1433 111.867 59.4963 111.867H102.357C102.71 111.867 102.992 112.149 102.992 112.503V114.128C102.992 114.481 102.71 114.764 102.357 114.764Z"
      fill="url(#paint10_linear_10073_64872)"
    />
    <g filter="url(#filter1_d_10073_64872)">
      <path
        d="M137.559 102.356H56.1228C55.1777 102.356 54.3901 101.568 54.3901 100.622V85.2535C54.3901 84.3077 55.1777 83.5195 56.1228 83.5195H137.559C138.504 83.5195 139.291 84.3077 139.291 85.2535V100.622C139.291 101.568 138.504 102.356 137.559 102.356Z"
        fill="url(#paint11_linear_10073_64872)"
      />
    </g>
    <path
      d="M62.8964 95.3417C64.2013 95.3417 65.2592 94.2831 65.2592 92.9772C65.2592 91.6714 64.2013 90.6128 62.8964 90.6128C61.5915 90.6128 60.5337 91.6714 60.5337 92.9772C60.5337 94.2831 61.5915 95.3417 62.8964 95.3417Z"
      fill="url(#paint12_linear_10073_64872)"
    />
    <path
      d="M121.019 94.5537H73.2132C72.8194 94.5537 72.5044 94.2384 72.5044 93.8443V92.0316C72.5044 91.6375 72.8194 91.3223 73.2132 91.3223H121.019C121.413 91.3223 121.728 91.6375 121.728 92.0316V93.8443C121.728 94.2384 121.413 94.5537 121.019 94.5537Z"
      fill="#BFDDFE"
    />
    <defs>
      <filter
        id="filter0_d_10073_64872"
        x="15.2008"
        y="18.5543"
        width="131.524"
        height="141.694"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="9.86199" />
        <feGaussianBlur stdDeviation="9.86199" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10073_64872"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10073_64872"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_10073_64872"
        x="32.3901"
        y="72.5195"
        width="128.901"
        height="62.8367"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10073_64872"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10073_64872"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_10073_64872"
        x1="19.9981"
        y1="139.999"
        x2="139.999"
        y2="19.9985"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_10073_64872"
        x1="80.9325"
        y1="26.0512"
        x2="80.9325"
        y2="131.765"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_10073_64872"
        x1="42.6194"
        y1="56.4685"
        x2="49.8182"
        y2="24.1549"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_10073_64872"
        x1="48.1284"
        y1="50.109"
        x2="52.368"
        y2="45.8724"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_10073_64872"
        x1="58.8602"
        y1="49.4024"
        x2="59.2389"
        y2="43.6331"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_10073_64872"
        x1="42.6194"
        y1="78.2321"
        x2="49.7612"
        y2="46.0405"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_10073_64872"
        x1="48.1284"
        y1="71.8727"
        x2="52.368"
        y2="67.6361"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_10073_64872"
        x1="58.8602"
        y1="71.2367"
        x2="59.2389"
        y2="65.4673"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_10073_64872"
        x1="42.6194"
        y1="121.83"
        x2="49.7612"
        y2="89.6381"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_10073_64872"
        x1="48.1284"
        y1="115.47"
        x2="52.368"
        y2="111.234"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_10073_64872"
        x1="58.8602"
        y1="114.764"
        x2="59.2389"
        y2="108.994"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_10073_64872"
        x1="96.813"
        y1="83.0838"
        x2="96.813"
        y2="102.559"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_10073_64872"
        x1="60.5336"
        y1="95.3416"
        x2="65.2625"
        y2="90.6161"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup></script>
